import { render, staticRenderFns } from "./EntrepreneurshipsListAdmin.vue?vue&type=template&id=d2034b04"
import script from "./EntrepreneurshipsListAdmin.vue?vue&type=script&lang=js"
export * from "./EntrepreneurshipsListAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports